
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25","fill":"none","viewBox":"0 0 24 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M21.533 22.244a1.466 1.466 0 0 1-1.466 1.466H3.933a1.466 1.466 0 0 1-1.466-1.466V3.177A1.467 1.467 0 0 1 3.933 1.71h10.393c.389 0 .761.155 1.037.43l5.741 5.741c.275.275.43.648.43 1.037v13.326Z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M21.394 8.335h-5.027c-.333 0-.653-.133-.889-.37a1.264 1.264 0 0 1-.368-.892V2.026m-.936 15.381h4.37m-13.05 3.182h13.05m-6.214-5.78c-1.139 1.14-3.507.72-4.362-.029-.855-.748-1.335-1.762-1.335-2.82 0-1.058.48-2.073 1.335-2.82 1.098-.961 3.223-1.169 4.363-.03m-6.837 1.853h3.989m-3.989 1.994h3.989"}}),_c('clipPath',{attrs:{"id":"icon-pricing__a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z","transform":"translate(0 .71)"}})])])
          )
        }
      }
    